import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { AuthProvider } from '@chocolate-soup-inc/cs-frontend-components';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './config/auth';
import './config/storage';
import { APIProvider } from './contexts/api';
import { FilterProvider } from './contexts/filters';
import reportWebVitals from './reportWebVitals';
import { AppRoutes } from './routes';

import '@chocolate-soup-inc/cs-frontend-components/index.css';
import './index.scss';

//const isProd = import.meta.env.REACT_APP_STAGE?.toLowerCase() == 'production';

loadDevMessages();
loadErrorMessages();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <AuthProvider>
      <APIProvider>
        <FilterProvider>
          <ToastContainer autoClose={5000} position='top-center' theme='dark' />
          <AppRoutes />
        </FilterProvider>
      </APIProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.debug);
